// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 매수 등록 화면 */

/* 필터 툴바 */
.buy-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

/* 체크박스 레이블 */
.buy-chk-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #444;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.buy-chk-label input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
  flex-shrink: 0;
}

.buy-toolbar select {
  padding: 5px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
}

/* 좌우 분할 레이아웃 */
.buy-body {
  display: flex;
  gap: 16px;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

/* 좌측 목록 패널 */
.buy-list-panel {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 그리드 셀 폰트 */
.buy-grid td {
  font-size: 12px;
}

/* 숫자 컬럼 우측정렬 */
.col-right {
  text-align: right;
  padding-right: 8px !important;
}

/* 매도완료 행 */
.row-sold {
  color: #bbb;
  background-color: #fafafa;
  cursor: default !important;
}

/* 다른 화면(건별수익률현황 메모 클릭 등)에서 넘어온 매수건 포커스 강조 */
.row-focus-highlight {
  animation: row-focus-flash 2.5s ease-out;
}
@keyframes row-focus-flash {
  0%   { background-color: #fff3cd; }
  100% { background-color: transparent; }
}

/* 보유/매도 뱃지 */
.badge-hold {
  background: #e8f5e9;
  color: #2e7d32;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
}

.badge-sold {
  background: #f0f0f0;
  color: #999;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 11px;
}

/* ── 우측 폼 패널 ── */
.buy-form-panel {
  width: 300px;
  flex-shrink: 0;
  background: white;
  border: 1px solid #e0e4ef;
  border-radius: 6px;
  padding: 14px 16px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.buy-form-title {
  font-size: 12px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

/* 라벨 + 입력 가로 레이아웃 */
.sf-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
}

.sf-row > label {
  width: 74px;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: #444;
  text-align: right;
}

.sf-row input[type="text"],
.sf-row input[type="number"],
.sf-row input[type="date"],
.sf-row select,
.sf-row textarea {
  flex: 1 1;
  min-width: 0;
  padding: 5px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  font-family: inherit;
  background: white;
  transition: border-color 0.2s;
}

.sf-row input:focus,
.sf-row select:focus,
.sf-row textarea:focus {
  outline: none;
  border-color: #4a90e2;
}

/* 폼 라벨 옆 도움말 아이콘 */
.sf-help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  margin-left: 4px;
  border-radius: 50%;
  background: #aaa;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  cursor: help;
  vertical-align: middle;
}

.sf-help:hover { background: #777; }

.sf-row select:disabled {
  background: #f5f5f5;
  color: #aaa;
  cursor: not-allowed;
}

/* 읽기전용 (차수, 매수금액) */
.input-readonly {
  background: #f8f8f8 !important;
  color: #666;
  cursor: default;
}

/* 메모 textarea는 라벨을 위에 정렬 */
.sf-row-memo {
  align-items: flex-start;
}

.sf-row-memo > label {
  margin-top: 6px;
}

/* 숫자 + 단위(%) */
.sf-input-suffix {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.sf-input-suffix input {
  flex: 1 1;
  min-width: 0;
}

.sf-suffix {
  font-size: 12px;
  color: #666;
  flex-shrink: 0;
}

/* 저장/취소 버튼 */
.sf-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding-left: 82px;
}

.required { color: #e74c3c; }

/* 종목명 컬럼 리사이즈 핸들 */
.col-resize-handle {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  cursor: col-resize;
  z-index: 1;
}

.col-resize-handle:hover {
  background: rgba(74, 144, 226, 0.35);
}

/* 수익률 색상 */
.rate-profit {
  color: #d32f2f;
  font-weight: 600;
}

.rate-loss {
  color: #1565c0;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/pages/trade/BuyPage.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,WAAW;EACX,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,4CAA4C;AAC5C;EACE,wCAAwC;AAC1C;AACA;EACE,OAAO,yBAAyB,EAAE;EAClC,OAAO,6BAA6B,EAAE;AACxC;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;;;EAKE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA,iBAAiB,gBAAgB,EAAE;;AAEnC;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,YAAY,cAAc,EAAE;;AAE5B,mBAAmB;AACnB;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* 매수 등록 화면 */\n\n/* 필터 툴바 */\n.buy-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* 체크박스 레이블 */\n.buy-chk-label {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: #444;\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n}\n\n.buy-chk-label input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.buy-toolbar select {\n  padding: 5px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n}\n\n/* 좌우 분할 레이아웃 */\n.buy-body {\n  display: flex;\n  gap: 16px;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n/* 좌측 목록 패널 */\n.buy-list-panel {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* 그리드 셀 폰트 */\n.buy-grid td {\n  font-size: 12px;\n}\n\n/* 숫자 컬럼 우측정렬 */\n.col-right {\n  text-align: right;\n  padding-right: 8px !important;\n}\n\n/* 매도완료 행 */\n.row-sold {\n  color: #bbb;\n  background-color: #fafafa;\n  cursor: default !important;\n}\n\n/* 다른 화면(건별수익률현황 메모 클릭 등)에서 넘어온 매수건 포커스 강조 */\n.row-focus-highlight {\n  animation: row-focus-flash 2.5s ease-out;\n}\n@keyframes row-focus-flash {\n  0%   { background-color: #fff3cd; }\n  100% { background-color: transparent; }\n}\n\n/* 보유/매도 뱃지 */\n.badge-hold {\n  background: #e8f5e9;\n  color: #2e7d32;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.badge-sold {\n  background: #f0f0f0;\n  color: #999;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-size: 11px;\n}\n\n/* ── 우측 폼 패널 ── */\n.buy-form-panel {\n  width: 300px;\n  flex-shrink: 0;\n  background: white;\n  border: 1px solid #e0e4ef;\n  border-radius: 6px;\n  padding: 14px 16px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.08);\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.buy-form-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 0 0 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #eee;\n}\n\n/* 라벨 + 입력 가로 레이아웃 */\n.sf-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 7px;\n}\n\n.sf-row > label {\n  width: 74px;\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #444;\n  text-align: right;\n}\n\n.sf-row input[type=\"text\"],\n.sf-row input[type=\"number\"],\n.sf-row input[type=\"date\"],\n.sf-row select,\n.sf-row textarea {\n  flex: 1;\n  min-width: 0;\n  padding: 5px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: inherit;\n  background: white;\n  transition: border-color 0.2s;\n}\n\n.sf-row input:focus,\n.sf-row select:focus,\n.sf-row textarea:focus {\n  outline: none;\n  border-color: #4a90e2;\n}\n\n/* 폼 라벨 옆 도움말 아이콘 */\n.sf-help {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 13px;\n  height: 13px;\n  margin-left: 4px;\n  border-radius: 50%;\n  background: #aaa;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  cursor: help;\n  vertical-align: middle;\n}\n\n.sf-help:hover { background: #777; }\n\n.sf-row select:disabled {\n  background: #f5f5f5;\n  color: #aaa;\n  cursor: not-allowed;\n}\n\n/* 읽기전용 (차수, 매수금액) */\n.input-readonly {\n  background: #f8f8f8 !important;\n  color: #666;\n  cursor: default;\n}\n\n/* 메모 textarea는 라벨을 위에 정렬 */\n.sf-row-memo {\n  align-items: flex-start;\n}\n\n.sf-row-memo > label {\n  margin-top: 6px;\n}\n\n/* 숫자 + 단위(%) */\n.sf-input-suffix {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n}\n\n.sf-input-suffix input {\n  flex: 1;\n  min-width: 0;\n}\n\n.sf-suffix {\n  font-size: 12px;\n  color: #666;\n  flex-shrink: 0;\n}\n\n/* 저장/취소 버튼 */\n.sf-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n  padding-left: 82px;\n}\n\n.required { color: #e74c3c; }\n\n/* 종목명 컬럼 리사이즈 핸들 */\n.col-resize-handle {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  width: 5px;\n  cursor: col-resize;\n  z-index: 1;\n}\n\n.col-resize-handle:hover {\n  background: rgba(74, 144, 226, 0.35);\n}\n\n/* 수익률 색상 */\n.rate-profit {\n  color: #d32f2f;\n  font-weight: 600;\n}\n\n.rate-loss {\n  color: #1565c0;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
